import React, { useState } from "react";
import { toast } from "react-toastify";

const AddPeriodForm = ({ onSave, onClose }) => {
    const [periodStartTm, setPeriodStartTm] = useState("");
    const [periodDuration, setPeriodDuration] = useState("");
    const [periodEndTm, setPeriodEndTm] = useState("");

    const handlePeriodStartTmChange = (value) => {
        setPeriodStartTm(value);
        if (value) {
            const [hours, minutes] = value.split(":").map(Number);
            const startTime = new Date();
            startTime.setHours(hours, minutes, 0, 0);
            const endTime = new Date(startTime.getTime() + periodDuration * 60 * 1000);
            const formattedEndTime = `${endTime.getHours().toString().padStart(2, "0")}:${endTime.getMinutes().toString().padStart(2, "0")}`;
            setPeriodEndTm(formattedEndTime);
        } else {
            setPeriodEndTm("");
        }
    };

    const handlePeriodDurationChange = (value) => {
        setPeriodDuration(value);
        if (periodStartTm) {
            const [hours, minutes] = periodStartTm.split(":").map(Number);
            const startTime = new Date();
            startTime.setHours(hours, minutes, 0, 0);
            const endTime = new Date(startTime.getTime() + value * 60 * 1000);
            const formattedEndTime = `${endTime.getHours().toString().padStart(2, "0")}:${endTime.getMinutes().toString().padStart(2, "0")}`;
            setPeriodEndTm(formattedEndTime);
        } else {
            setPeriodEndTm("");
        }
    };

    const handleSave = () => {
        if (periodStartTm === "") {
            toast.warn("Please enter start time");
            return;
        }
        if (periodDuration < 0 || periodDuration > 120) {
            toast.warn("Please enter valid duration");
            return;
        }
        const newPeriod = {
            startTm: periodStartTm,
            duration: periodDuration,
            endTm: periodEndTm,
        };
        onSave(newPeriod);
    };

    return (
        <div className="periodFormPopup">
            <div className="col-sm-12 padding-remove" style={{ height: "50px" }}>
                <div className="col-sm-8" style={{ fontSize: "large" }}>
                    Add Period
                </div>
                <div className="col-sm-4 padding-remove">
                    <button
                        type="button"
                        title="Close Popup"
                        onClick={onClose}
                        className="btn btn-info text-center pull-right"
                    >
                        X
                    </button>
                </div>
            </div>
            <div className="col-sm-10 col-xs-12 col-centered padding-remove" style={{ height: "50px" }}>
            <div className="form-group col-md-12" style={{ padding: "5px 0" }}>
                <div className="form-group col-md-12 padding-remove">
                    <label className="control-label col-md-4 col-xs-6" style={{ padding: "7px 0 0 0" }}>
                        Start Time:
                    </label>
                    <div className="col-md-6 col-sm-6 col-xs-12">
                        <input
                            type="text"
                            className="form-control"
                            value={periodStartTm}
                            onChange={(e) => handlePeriodStartTmChange(e.target.value)}
                            placeholder="08:00"
                        />
                    </div>
                </div>
                <div className="form-group col-md-12 padding-remove">
                    <label className="control-label col-md-4" style={{ padding: "7px 0 0 0" }}>
                        Duration:
                    </label>
                    <div className="col-sm-6">
                        <input
                            type="number"
                            className="form-control"
                            min="0"
                            value={periodDuration}
                            onChange={(e) => handlePeriodDurationChange(Math.max(0, Number(e.target.value)))}
                            placeholder="40"
                        />
                    </div>
                </div>
                <div className="form-group col-md-12 padding-remove">
                    <label className="control-label col-md-4" style={{ padding: "7px 0 0 0" }}>
                        End Time:
                    </label>
                    <div className="col-sm-6">
                        <input
                            type="text"
                            className="form-control"
                            value={periodEndTm}
                            disabled
                            placeholder="End Time"
                        />
                    </div>
                    </div>
                </div>
                <div className="col-sm-10 padding-remove" style={{ height: "50px", marginTop: "15px" }}>
                    <div className="col-sm-2 col-md-2 padding-remove pull-right">
                        <button type="button" className="btn btn-info" onClick={handleSave}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddPeriodForm;